import type { ReactNode } from 'react';

export function AdminPageHeader({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
      <div>
        <p className="text-xs font-black uppercase tracking-[.14em] text-[var(--accent)]">
          Operação da plataforma
        </p>
        <h1 className="mt-2 text-3xl font-black tracking-[-.035em] sm:text-4xl">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-[var(--muted-foreground)]">
          {description}
        </p>
      </div>
      {action}
    </div>
  );
}
